import React from 'react';
import Footer from '../../components/Footer/Footer';

const Section = ({ title, children }) => (
  <div className='mb-8'>
    <h2 className='text-xl font-bold font-raleway mb-3' style={{ color: '#004e80' }}>{title}</h2>
    <div className='text-gray-700 text-sm leading-relaxed space-y-3'>
      {children}
    </div>
  </div>
);

const Li = ({ children }) => (
  <li className='flex items-start gap-2'>
    <span className='mt-1 w-1.5 h-1.5 rounded-full flex-shrink-0' style={{ backgroundColor: '#c76f36' }} />
    <span>{children}</span>
  </li>
);

function PoliticaPrivacidade() {
  return (
    <section className='flex flex-col absolute min-h-full w-full'>

      {/* Hero */}
      <div className='w-full pt-24 pb-10 px-6' style={{ backgroundColor: '#004e80' }}>
        <div className='max-w-3xl mx-auto'>
          <p className='text-sm font-semibold mb-2' style={{ color: '#f5be88' }}>Transparência e privacidade</p>
          <h1 className='text-3xl font-extrabold font-raleway text-white'>Política de Privacidade</h1>
          <p className='text-gray-300 text-sm mt-3'>
            Última atualização: {new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' })}
          </p>
        </div>
      </div>

      {/* Conteúdo */}
      <div className='w-full py-12 px-6 flex-1 bg-white'>
        <div className='max-w-3xl mx-auto'>

          <Section title="1. Quem somos">
            <p>
              A <strong>Objetiva — Soluções em Consórcio S/S Ltda</strong>, inscrita no CNPJ sob o nº 13.282.501/0001-50,
              com sede na Rua Espírito Santo, 273, Aclimação, São Paulo/SP, CEP 01526-020, é a controladora dos dados
              pessoais tratados neste site, nos termos da Lei Geral de Proteção de Dados (Lei nº 13.709/2018 — LGPD).
            </p>
            <p>
              Para dúvidas ou exercício de direitos relacionados aos seus dados, entre em contato pelo e-mail:{' '}
              <a href='mailto:contato@objetivaconsorcio.com.br' className='underline' style={{ color: '#004e80' }}>
                contato@objetivaconsorcio.com.br
              </a>
            </p>
          </Section>

          <Section title="2. Quais dados coletamos">
            <p>Coletamos dados pessoais nas seguintes situações:</p>
            <ul className='space-y-2 mt-2'>
              <Li><strong>Formulário de contato:</strong> nome, e-mail, empresa, telefone e mensagem.</Li>
              <Li><strong>Calculadora / proposta de compra:</strong> valor do crédito, percentual amortizado, data de encerramento do grupo, nome, e-mail e telefone do interessado.</Li>
              <Li><strong>Programa de Parceria Remunerada (PPR):</strong> nome, e-mail, telefone e senha para acesso à área restrita.</Li>
              <Li><strong>Navegação:</strong> endereço IP, páginas acessadas, tempo de sessão e dados de comportamento coletados por ferramentas de análise (mediante consentimento).</Li>
            </ul>
          </Section>

          <Section title="3. Como usamos seus dados">
            <ul className='space-y-2'>
              <Li>Responder solicitações enviadas pelo formulário de contato.</Li>
              <Li>Apresentar e negociar propostas de compra de cotas canceladas.</Li>
              <Li>Gerenciar o cadastro e as indicações do Programa de Parceria Remunerada.</Li>
              <Li>Enviar comunicações sobre o andamento de negociações (com base no contrato ou legítimo interesse).</Li>
              <Li>Analisar o tráfego do site para melhorar a experiência do usuário (somente com consentimento).</Li>
              <Li>Apoiar ações de marketing e automação (somente com consentimento).</Li>
            </ul>
          </Section>

          <Section title="4. Cookies e tecnologias de rastreamento">
            <p>
              Utilizamos dois tipos de cookies:
            </p>
            <div className='mt-2 space-y-4'>
              <div>
                <p className='font-semibold text-gray-800'>Cookies essenciais (sempre ativos)</p>
                <ul className='space-y-1 mt-1'>
                  <Li><strong>token</strong> — JWT de sessão para manter o usuário logado no PPR. Sem esse cookie o sistema de autenticação não funciona.</Li>
                </ul>
              </div>
              <div>
                <p className='font-semibold text-gray-800'>Cookies de analytics e marketing (requerem consentimento)</p>
                <ul className='space-y-1 mt-1'>
                  <Li><strong>Google Tag Manager (GTM-NWLLW7VG)</strong> — gerencia tags de análise e marketing.</Li>
                  <Li><strong>LeadStaker</strong> — rastreamento de visitantes e captura de leads.</Li>
                  <Li><strong>RD Station</strong> — automação de marketing e análise de comportamento.</Li>
                </ul>
              </div>
            </div>
            <p className='mt-3'>
              Você pode alterar sua preferência de cookies a qualquer momento limpando o armazenamento local do navegador
              (localStorage) e recarregando o site.
            </p>
          </Section>

          <Section title="5. Compartilhamento de dados">
            <p>Seus dados podem ser compartilhados com:</p>
            <ul className='space-y-2 mt-2'>
              <Li><strong>Brevo (ex-Sendinblue):</strong> plataforma de envio de e-mails transacionais.</Li>
              <Li><strong>RD Station:</strong> plataforma de automação de marketing.</Li>
              <Li><strong>Google:</strong> serviços de análise e gerenciamento de tags.</Li>
              <Li><strong>Reclame Aqui:</strong> exibição do selo de empresa verificada.</Li>
            </ul>
            <p className='mt-3'>
              Não vendemos, alugamos nem cedemos seus dados pessoais a terceiros para fins próprios destes.
              O compartilhamento se limita ao necessário para a prestação dos serviços descritos nesta política.
            </p>
          </Section>

          <Section title="6. Por quanto tempo guardamos seus dados">
            <ul className='space-y-2'>
              <Li>Dados de contato e proposta: pelo tempo necessário para a negociação e, após o encerramento, pelo prazo legal aplicável (mínimo 5 anos, conforme legislação civil e fiscal).</Li>
              <Li>Dados do PPR: enquanto o cadastro estiver ativo e por até 5 anos após o encerramento.</Li>
              <Li>Dados de navegação (cookies): conforme o prazo definido por cada ferramenta de terceiro.</Li>
            </ul>
          </Section>

          <Section title="7. Seus direitos como titular">
            <p>Nos termos da LGPD, você tem direito a:</p>
            <ul className='space-y-2 mt-2'>
              <Li>Confirmar a existência de tratamento dos seus dados.</Li>
              <Li>Acessar os dados que mantemos sobre você.</Li>
              <Li>Corrigir dados incompletos, inexatos ou desatualizados.</Li>
              <Li>Solicitar a anonimização, bloqueio ou eliminação de dados desnecessários.</Li>
              <Li>Portabilidade dos seus dados a outro fornecedor de serviço.</Li>
              <Li>Revogar o consentimento a qualquer momento, sem prejuízo do tratamento realizado anteriormente.</Li>
              <Li>Opor-se ao tratamento realizado com base em legítimo interesse.</Li>
            </ul>
            <p className='mt-3'>
              Para exercer qualquer desses direitos, envie um e-mail para{' '}
              <a href='mailto:contato@objetivaconsorcio.com.br' className='underline' style={{ color: '#004e80' }}>
                contato@objetivaconsorcio.com.br
              </a>{' '}
              com o assunto <strong>"LGPD — Exercício de Direitos"</strong>.
              Responderemos em até 15 dias úteis.
            </p>
          </Section>

          <Section title="8. Segurança">
            <p>
              Adotamos medidas técnicas e organizacionais para proteger seus dados contra acesso não autorizado,
              perda, destruição ou divulgação indevida, incluindo controle de acesso por autenticação JWT,
              comunicação via HTTPS e limitação de acesso interno aos dados.
            </p>
          </Section>

          <Section title="9. Alterações nesta política">
            <p>
              Esta política pode ser atualizada periodicamente. A data de última atualização sempre será indicada
              no topo desta página. Recomendamos que você a consulte regularmente.
            </p>
          </Section>

          <Section title="10. Contato e Encarregado (DPO)">
            <p>
              Dúvidas, solicitações ou reclamações relacionadas à privacidade e proteção de dados devem ser
              direcionadas ao responsável pelo tratamento de dados da Objetiva:
            </p>
            <div className='mt-3 p-4 rounded-lg' style={{ backgroundColor: '#f0f7ff' }}>
              <p className='font-semibold text-gray-800'>Objetiva — Soluções em Consórcio S/S Ltda</p>
              <p>E-mail: <a href='mailto:contato@objetivaconsorcio.com.br' className='underline' style={{ color: '#004e80' }}>contato@objetivaconsorcio.com.br</a></p>
              <p>Telefone: (11) 3399-5653</p>
              <p>Endereço: Rua Espírito Santo, 273 — Aclimação, São Paulo/SP — CEP 01526-020</p>
            </div>
          </Section>

        </div>
      </div>

      <Footer />
    </section>
  );
}

export default PoliticaPrivacidade;
